import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function PortableScreenSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("portableScreen.title")}</title>
        <meta name="keywords" content={t("portableScreen.keywords")} />
        <meta name="description" content={t("portableScreen.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a2d42]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/portable-screen-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_15.8%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f1f30]/92 via-[#0f1f30]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("portableScreen.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("portableScreen.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("portableScreen.knowledgeBase.rootLabel")}
        rootColor="#7c3aed"
        treeTranslationKey="portableScreen.knowledgeBase.tree"
        i18nPrefix="portableScreen.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="portableScreen"
        images={{
          painPoints: "/solutions/portable-screen-pain.jpeg",
          solutions: "/solutions/portable-screen-solutions.jpeg",
          cta: "/solutions/portable-screen-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "65% 22%",
          solutions: "58% 25%",
          cta: "50% 10%",
        }}
      />
    </>
  );
}
